// extracted by mini-css-extract-plugin
module.exports = {"recentSearches":"ob_dyJkzv","recentSearches__mobile":"ob_mIJybL","recentSearches__title":"ob_0HtHkJ","recentSearches__items":"ob_puBJPt"};